import React from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";

import rocket from '../../theme/assets/other/lp_about_s6_rocket.png';

import icon1 from '../../theme/assets/svg/lp_about_s6_icon1.svg';
import icon2 from '../../theme/assets/svg/lp_about_s6_icon2.svg';
import icon3 from '../../theme/assets/svg/lp_about_s6_icon3.svg';


const AboutS6 = () => {
    const { t } = useTranslation();

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.imgWrap}`}>
                    <img src={rocket} alt={t('Ценности')}/>
                </div>
                <div className={`${Styles.textWrap}`}>
                    <div className={`${Styles.contentWrapTitle}`}>{t('Наш')} <span>{t('подход')}</span></div>
                    <div className={`${Styles.contentBox}`}>
                        <div className={`${Styles.contentBoxItem}`}>
                            <div className={`${Styles.contentBoxItemTitleRow}`}>
                                <div className={`${Styles.contentBoxItemTitleRowIcon}`}>
                                    <img src={icon1} alt={t('Тщательный отбор проектов')}/>
                                </div>
                                <div className={`${Styles.contentBoxItemTitleRowText}`}>{t('Тщательный отбор проектов')}</div>
                            </div>
                            <div className={`${Styles.contentBoxItemNote}`}>{t('Мы работаем только с проектами, которые проходят строгий предварительный отбор. Ещё до запуска мы оцениваем команду, продуктовую визию и реалистичность планов.')} <span>{t('Фокус — не на количестве запусков, а на соблюдении высоких стандартов.')}</span></div>
                        </div>
                        <div className={`${Styles.contentBoxItem}`}>
                            <div className={`${Styles.contentBoxItemTitleRow}`}>
                                <div className={`${Styles.contentBoxItemTitleRowIcon}`}>
                                    <img src={icon2} alt={t('Устойчивая токеномика и реализация')}/>
                                </div>
                                <div className={`${Styles.contentBoxItemTitleRowText}`}>{t('Устойчивая токеномика и реализация')}</div>
                            </div>
                            <div className={`${Styles.contentBoxItemNote}`}>{t('Мы анализируем токеномику проекта: распределение, стимулы, вестинг и устойчивость модели. Также проверяем дорожную карту и способность команды выполнять заявленные этапы.')} <span>{t('Наша цель — запускать проекты, способные стабильно работать и расти в долгосрочной перспективе.')}</span></div>
                        </div>
                        <div className={`${Styles.contentBoxItem}`}>
                            <div className={`${Styles.contentBoxItemTitleRow}`}>
                                <div className={`${Styles.contentBoxItemTitleRowIcon}`}>
                                    <img src={icon3} alt={t('Честный запуск и долгосрочное выравнивание интересов')}/>
                                </div>
                                <div className={`${Styles.contentBoxItemTitleRowText}`}>{t('Честный запуск и долгосрочное выравнивание интересов')}</div>
                            </div>
                            <div className={`${Styles.contentBoxItemNote}`}>{t('Мы не используем механики pay-to-win и не продаём доступ. Условия участия прозрачны и едины для всех.')} <span>{t('Интересы проекта и сообщества согласованы с первого дня, а запуск становится точкой старта долгосрочного роста.')}</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutS6;




